module.exports = __webpack_public_path__ + "img/DIDA.beaf048b.png";